// src/data/hireNodejsPageData.js

export const hireNodePageContent = {
  // Helmet Content
  helmet: {
    title: "Hire Node Js Developers | Node Development Services",
    description: "Hire top Node.js developers for efficient, scalable backend solutions. Expert Node.js development services for your business growth.",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-node.avif)`,
    image: "", // Keep if it's dynamic, otherwise remove
    mainHeading: "Hire Expert Node.js Developers for Scalable & High-Performance Solutions",
    content: "Whether you're a startup or an enterprise, our top-tier Node.js developers specialize in building fast, secure, & scalable applications tailored to your business needs.",
    btnText: "Consult our node developers",
    bannerList: [
      { list: "Freelance & Full-Time Developers" },
      { list: "Flexible Hiring Models" },
      { list: "Global Talent Pool" },
    ],
  },

  // Node.js Expertise Section
  nodeExpertise: { // Changed from 'HireNodejsServicesData' for consistency & clarity
    btnText: "Schedule a Call Today",
    heading: "Our Node.js Development Expertise",
    description: "Our Node.js developers specialize in building high-performance, scalable backend systems for businesses of all sizes. From real-time applications to enterprise-grade solutions, we ensure seamless integration, fast performance, & top-tier security.",
    servicesData: [
      {
        title: "Node.js Consulting",
        description: "Get expert guidance on architecture, performance optimization, & scalability to maximize the potential of your Node.js applications.",
        icon: "/images/hire-page-icons/hrie-node-icons1.svg",
      },
      {
        title: "Node.js Web Development",
        description: "We build feature-rich, responsive, & scalable web apps using Node.js, ensuring smooth functionality across all devices & platforms.",
        icon: "/images/hire-page-icons/hrie-node-icons2.svg",
      },
      {
        title: "Node.js API Development",
        description: "Our developers create robust & efficient APIs, enabling seamless communication between applications & enhancing system connectivity.",
        icon: "/images/hire-page-icons/hrie-node-icons3.svg",
      },
      {
        title: "Node.js CMS & Portal Development",
        description: "Develop custom CMS & web portals that are intuitive, scalable, & easy to manage, designed to fit your business needs.",
        icon: "/images/hire-page-icons/hrie-node-icons4.svg",
      },
      {
        title: "Migration to Node.js",
        description: "Seamlessly migrate your existing applications to Node.js with minimal downtime, ensuring improved performance & maintainability.",
        icon: "/images/hire-page-icons/hrie-node-icons5.svg",
      },
      {
        title: "Integration with Existing Solutions",
        description: "We specialize in integrating Node.js applications with third-party services & platforms, creating a unified & streamlined system.",
        icon: "/images/hire-page-icons/hrie-node-icons6.svg",
      },
      {
        title: "Node.js eCommerce Solutions",
        description: "Build secure, high-performance eCommerce platforms that offer a seamless shopping experience, scalability, & enhanced security.",
        icon: "/images/hire-page-icons/hrie-node-icons7.svg",
      },
      {
        title: "Node.js Support & Maintenance",
        description: "Ensure optimal performance with our ongoing support & maintenance services, keeping your app updated, secure, & running smoothly.",
        icon: "/images/hire-page-icons/hrie-node-icons8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "Hire a developer today",
    heading: "Why Hire Node.js Developers ",
    greenHeading: "from Bitsclan?",
    subHeading: "At Bitsclan, we leverage Node.js alongside cutting-edge frontend & mobile technologies to build powerful, scalable, & high-performing applications tailored to your business needs. Whether you're developing a web platform or mobile solution, we ensure efficiency, security, & an exceptional user experience.",
    solutionsData: [ // Renamed from HireNodejsSolutionsData
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "Access Vetted Node.js Experts",
        description: "Hire top-tier Node.js developers who are pre-vetted for their technical expertise, problem-solving skills, & English fluency, ensuring clear communication & high-quality development.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "Find the Right Match Instantly",
        description: "No more wasting time on endless resumes! Our AI-driven hiring process instantly connects you with the best Node.js developers, making hiring fast, easy, & hassle-free.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "Save Big with Global Talent",
        description: "Tap into a network of 450,000+ developers across 190+ countries & cut hiring costs by up to 58%—without compromising on quality.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "Get Personalized Hiring Support",
        description: "Finding the right developer can be challenging. That’s why our expert recruiters guide you through every step, ensuring you make the best hiring decision with confidence.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: { // Renamed from techCombinations
    heading: "Top Node.js Combinations for High-Performance Development",
    description: "Leverage the power of Node.js with the best technology combinations to build fast, scalable, & efficient applications. Hire expert Node.js developers to ensure seamless backend development & exceptional performance.",
    combinations: [
      {
        title: "Node.js + React + MongoDB",
        description:
          "Node.js as the backend with React on the front end & MongoDB as the database helps build fast, scalable, & real-time web applications.",
        icons: [
          { src: "nodejs.svg", altText: "Node.js backend runtime" },
          { src: "react.svg", altText: "React.js frontend library" },
          { src: "mongodb.svg", altText: "MongoDB NoSQL database" },
        ],
      },
      {
        title: "Node.js + Angular + MySQL",
        description:
          "Angular for a structured front-end, Node.js for a high-performance backend, & MySQL as the database create a powerful full-stack web solution.",
        icons: [
          { src: "nodejs.svg", altText: "Node.js backend runtime" },
          { src: "angular.svg", altText: "Angular front-end framework" },
          { src: "mysql-whale-icon.svg", altText: "MySQL relational database" },
        ],
      },
      {
        title: "Node.js + Vue.js + PostgreSQL",
        description:
          "Vue.js on the front end, Node.js as the backend, & PostgreSQL as a database ensure secure & efficient development of modern applications.",
        icons: [
          { src: "nodejs.svg", altText: "Node.js backend runtime" },
          { src: "vue-js.svg", altText: "Vue.js front-end framework" },
          { src: "postgres.svg", altText: "PostgreSQL relational database" },
        ],
      },
      {
        title: "Node.js + GraphQL + DynamoDB",
        description:
          "GraphQL enables efficient data querying, Node.js manages the server logic, & DynamoDB offers scalable NoSQL storage for highly interactive applications.",
        icons: [
          { src: "nodejs.svg", altText: "Node.js backend runtime" },
          { src: "graphql.svg", altText: "GraphQL query language" },
          { src: "dynamodb.svg", altText: "Amazon DynamoDB NoSQL database" },
        ],
      },
    ],
  },

  // Hire Steps
  hireSteps: { // Renamed from HireNodejsSteps
    btnText: "Let’s Find Your Perfect Developer",
    heading: "Hire Node.js Developers in 4 Simple Steps",
    subHeading: "Finding the perfect Node.js developer is quick & hassle-free with our streamlined 4-step hiring process.",
    steps: [
      {
        title: "Choose your Engagement Model",
        description: "Select a hiring model that aligns with your project needs—Full-Time, Part-Time, or Hourly. We offer flexible options to match your budget & timeline.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "Screen & Select Node.js Developers",
        description: "Get access to a curated list of top Node.js developers. Review their profiles, experience, & skills to find the best fit for your project.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "Conduct One-on-One Interview",
        description: "Assess shortlisted candidates through technical interviews & live coding tests. Evaluate their problem-solving skills, experience, & cultural fit.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "Seamless Onboarding in 24-48 Hours",
        description: "Once you’ve made your choice, your Node.js developer joins your team within 24-48 hours—ensuring a fast, smooth start to your project.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: { // Renamed from tabs & tabItems
    whereStart: "Backend",
    mainHeading: "Hire Expert Node.js Developers for Scalable & High-Performance Web Solutions",
    subHeading: "At Bitsclan, we empower your backend development journey with a cutting-edge Node.js tech stack that ensures speed, scalability, & efficiency. Our experienced Node.js developers specialize in building real-time, data-intensive applications tailored to your business needs.",
    tabs: [
      "Backend",
      "Databases",
      "Cloud & DevOps",
      "Testing",
      "Tools & Utilities",
    ],
    tabItems: [
      { tab: "Backend", name: "Express.js", icon: "/images/database5.png" },
      { tab: "Backend", icon: "/images/database2.png", name: "Nest Js" },
      { tab: "Databases", name: "MongoDB", icon: "/images/db3.png" },
      { tab: "Databases", name: "PostgreSQL", icon: "/images/tech-stack-icons/postgres.svg" },
      { tab: "Databases", name: "MySQL", icon: "/images/db5.png" },
      { tab: "Cloud & DevOps", name: "AWS", icon: "/images/cloud3.png" },
      { tab: "Cloud & DevOps", name: "Docker", icon: "/images/tech-stack-icons/docker.svg" },
      { tab: "Cloud & DevOps", name: "Kubernetes", icon: "/images/tech-stack-icons/kubernetes.svg" },
      { tab: "Testing", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
      { tab: "Testing", icon: "/images/tech-stack-icons/seaborn.svg", name: "Jmeter" },
      { tab: "Testing", icon: "/images/tech-stack-icons/selenium.svg", name: "Selenium" },
      { tab: "Testing", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
      { tab: "Tools & Utilities", name: "TypeScript", icon: "/images/tech-stack-icons/typescript.svg" },
      { tab: "Tools & Utilities", name: "GraphQL", icon: "/images/tech-stack-icons/graphql.svg" },
    ],
  },

  // Expert Facts
  expertFacts: { // Renamed from HireNodejsFactsData & mainBannerImg for background
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our Node.js Team",
    facts: [
      {
        text: "Expert Node.js Developers – Our team consists of highly skilled professionals specializing in scalable backend development with Node.js.",
      },
      {
        text: " Enterprise-Grade Solutions – We build powerful backend systems that support everything from small apps to large-scale enterprise platforms.",
      },
      { text: "Deep JavaScript & Node.js Expertise – Our developers are proficient in Node.js frameworks & modern JavaScript for fast, reliable application development." },
      {
        text: " Seamless API Development – We design & optimize APIs, ensuring your applications integrate smoothly with third-party services & platforms.",
      },
      { text: "High-Performance, Real-Time Apps – Our team excels at developing real-time applications that scale effortlessly as your business grows." },
      { text: "Full-System Integration – We specialize in connecting Node.js applications with databases, cloud services, & external tools for seamless compatibility." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-node.avif)`, // From mainBannerImg.factBackgroundImage
  },

  // App Idea Section
  appIdeaSection: { // Renamed from HirePageAppIdea
    heading: "Validate Your App Idea with a Prototype in Just 6-8 Weeks!",
    content: "Have an app idea but unsure how to proceed? Our expert Node.js developers can help you bring it to life with a fully functional prototype in just 6-8 weeks!",
  },

  // Engagement Models
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    hiringDetails: [ // Renamed from hiringDetails
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg", // Added full path
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg", // Added full path
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg", // Added full path
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // FAQ Section
  faqSection: { // Renamed from HireNodejsFaqData
    mainHeading: "Frequently Asked Questions",
    subHeading: "Discover answers to common questions about Node.js",
    faqData: [
      {
        id: "collapseOne",
        question: "What is Node.js used for?",
        answer: "Node.js is commonly used for building fast, scalable backend applications. It is perfect for creating real-time applications, APIs, & backend services that can handle large volumes of requests.",
      },
      {
        id: "collapseTwo",
        question: "Why should I hire Node.js developers from Arc?",
        answer: "Our Node.js developers are experts at creating fast, scalable backend systems. They have the skills to ensure your application performs well & integrates seamlessly with other services.",
      },
      {
        id: "collapseThree",
        question: "How long does it take to develop a Node.js application?",
        answer: "The timeline depends on the complexity of the project. Small to medium apps can take a few weeks, while larger systems may take a few months. We work with you to set realistic deadlines.",
      },
      {
        id: "fourth",
        question: "Can you migrate my existing app to Node.js?",
        answer: "Yes! Our Node.js experts can help you migrate your existing applications to Node.js, ensuring the transition is smooth & your app continues to run efficiently.",
      },
      {
        id: "fifth",
        question: "What kind of apps can be built with Node.js? ",
        answer: "You can build a wide range of applications using Node.js, including eCommerce platforms, real-time chat applications, APIs, CMS, & more. It’s great for high-performance, real-time apps.",
      },
      {
        id: "sixth",
        question: "How does Node.js improve app performance?",
        answer: "Node.js is fast & lightweight. It uses a non-blocking, event-driven architecture, which helps it handle many requests simultaneously. This makes your app faster & more scalable.",
      },
    ],
  },
  // You can remove or keep these if they are not directly used by components anymore
  // HireNodejsStacksdata: [],
  // HireNodejsBenefitsData: [],
  // HireNodejsWhoWeServeData: [],
  // HireNodejsPageDeliverData: [],
  // HireNodejsSlidesData: [],
};